export const environment = {
  production: true,
  apiURL: 'https://gym-api.onerepsoftware.com',
  stripePublishableKey: 'pk_live_51N31RWHZ7R1RKAu7ELXizfeJqzsCN1dYbElI5dYR5hDsNvAmLbtVwzisYk8eGTuglDeKHaPNLgyqmmwsdoDnclRS00o1zznhXb',
  subdomainBase: 'gym-portal\.onerepsoftware\.com',
  appUrl: 'https://gym-portal.onerepsoftware.com',
  googleMapsKey: 'AIzaSyCJLvZLfCgAkChdVX5g_XEA5PRpfPVAyns',
};
